import type { ComponentProps, ReactNode } from "react"
import { cn } from "@/utilities"

interface AuthShellProps extends ComponentProps<"section"> {
  title: string
  children: ReactNode
}

export const AuthShell = ({
  title,
  children,
  className,
  ...props
}: AuthShellProps) => {
  return (
    <section className='flex w-full justify-center px-4' {...props}>
      <div
        className={cn(
          "w-full max-w-100 rounded-xl border bg-white p-6 shadow-sm md:p-8",
          className
        )}
      >
        <h1 className='mb-6 text-center font-semibold text-2xl'>{title}</h1>
        {children}
      </div>
    </section>
  )
}
